export const invitations = {
  discount: {
    ariaLabel: 'Voortgang korting: {{completed}} van {{total}} stappen voltooid',
  },
  discountProgress: {
    currentDiscount: 'Je ontvangt momenteel {{percentage}}% korting',
    hint_one: 'Nodig nog {{count}} vriend uit',
    hint_other: 'Nodig nog {{count}} vrienden uit',
    savedLabel: 'Je bespaarde al',
    step: '{{percentage}}% korting op jouw vergoeding',
  },
  cta: {
    share: {
      data: {
        text: 'Hi! Ken jij Creative Shelter al? Ik factureer via hen mijn auteursrechten en hou zo meer centen over. Ook eens proberen? Factureer 60 dagen gratis en voor niets. (Nog meer overhouden dus!)',
        title: 'Het Craft-platform van Creative Shelter',
      },
      permissionDenied: 'Je moet toestemming geven om je uitnodigingslink te kunnen delen.',
    },
    socials: {
      twitter: {
        hashtags: '#auteursrechten #meerverdienen #creativeshelter',
        text: 'Jij daar! Ken je Creative Shelter al? Ik factureer via hen mijn auteursrechten en hou zo meer centen over. Ook eens proberen? Factureer 60 dagen gratis en voor niets!',
      },
    },
  },
  hero: {
    buttons: {
      copyLink: 'Kopieer link',
      copyLinkSuccess: 'Gekopieerd!',
      email: 'Stuur een e-mail',
      share: 'Deel',
    },
    description:
      'Stuur je persoonlijke link. Zodra je collega zijn eerste factuur verstuurt, krijg jij 25% korting op jouw vergoeding aan Creative Shelter en je vriend factureert 60 dagen gratis.',
    shareVia: 'of deel via',
    socials: {
      facebook: 'Deel via Facebook',
      linkedin: 'Deel via LinkedIn',
      whatsapp: 'Deel via WhatsApp',
      x: 'Deel via X',
    },
    title: 'Nodig een vriend uit en ontvang korting',
  },
  howItWorks: {
    disclaimer:
      'De korting van 25% is één jaar geldig en gaat in zodra je collega-freelancer een eerste factuur verstuurd heeft, binnen de 30 dagen na het aanmaken van een account. Voor de persoon die je uitgenodigd hebt, gaat de korting direct in na de registratie.',
    steps: {
      earn: 'Jij verdient 25% vergoedingskorting per collega die factureert',
      invoice: 'Je collega factureert 60 dagen lang gratis',
      register: 'Je collega registreert zich met jouw link',
    },
    title: 'Hoe werkt het?',
  },
  sendInvitationDialog: {
    errors: {
      accountAlreadyExists: 'Deze persoon factureert al via Creative Shelter.',
      noDoubleInvite: 'Je hebt al een uitnodiging naar dit e-mailadres verstuurd.',
      noSelfInvite: 'Je kan jezelf niet uitnodigen!',
      userAlreadyExists: 'Deze persoon factureert al via Creative Shelter.',
    },
    form: {
      inviteeEmailAddressField: {
        label: 'E-mailadres',
      },
      inviteeFirstNameField: {
        label: 'Voornaam',
      },
      inviteeLanguageField: {
        label: 'Taal',
      },
      inviteeLastNameField: {
        label: 'Achternaam',
      },
      submitButton: 'Verzend',
    },
    success: 'Je uitnodiging is succesvol verzonden en is onderweg naar {{ name }}.',
    title: 'Nodig iemand uit',
  },
  sentInvitations: {
    headers: {
      email: 'E-mail',
      name: 'Naam',
      status: 'Status',
    },
    status: {
      accepted: 'Geregistreerd',
      declined: 'Geweigerd',
      pending: 'In afwachting',
    },
    title: 'Verstuurde uitnodigingen',
  },
  title: 'Vrienden uitnodigen',
};
